/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import * as _ from 'lodash';
import { hasPlayerScored, hasPlayerWarning } from '../../utils/matchevents';
import { getProxyUrl } from '../../utils/image';

function FutsalFormation({ match, homeTeamLogo, visitingTeamLogo }) {
  const homeTeamPlayers = _.concat(
    match?.homeTeamLineup?.starting,
    match?.homeTeamLineup?.substitutes
  ).filter(Boolean);
  const visitingTeamPlayers = _.concat(
    match?.visitingTeamLineup?.starting,
    match?.visitingTeamLineup?.substitutes
  ).filter(Boolean);

  const { homeTeamName, visitingTeamName } = match;

  const renderPlayer = (player) => {
    const showGoalIcon = hasPlayerScored(player, match?.matchEvents);
    const showWarningIcon = hasPlayerWarning(player, match?.matchEvents);

    return (
      <div className="data-container__row px-4 py-1 d-flex align-items-center">
        <div className="d-flex align-items-center">
          <div className="player-bust__number player-bust__number--lineup fw-bold">
            {player?.number}
          </div>
          <div className="player-bust__name player-bust__name--lineup d-flex fw-bold">
            {`${player?.givenName} ${player?.surName}`}
          </div>
        </div>
        <div className="d-flex gap-2 ms-auto align-items-center">
          {showGoalIcon && (
              showGoalIcon.map(() =>
                <img
                    src="/wp-content/themes/sef-leagues/images/football-logo.svg"
                    alt=""
                />
            )
          )}
          {showWarningIcon && <div className="yellow-card" />}
        </div>
      </div>
    );
  };

  return (
    <section className="row mt-5">
      <div className="col-12 col-lg">
        <div className="row">
          <div className="col-12 col-lg-6 mb-4">
            <div className="data-container">
              <div className="data-container__row data-container__header px-4 py-3 align-items-center gap-3 d-flex">
                <img
                  height="35"
                  src={getProxyUrl(homeTeamLogo, 35, 35)}
                  alt=""
                />
                <span className="heading-h5 text-transform-none">
                  {homeTeamName}
                </span>
              </div>
              {homeTeamPlayers.map((p) => renderPlayer(p))}
            </div>
          </div>
          <div className="col-12 col-lg-6 mb-4">
            <div className="data-container">
              <div className="data-container__row data-container__header px-4 py-3 align-items-center gap-3 d-flex justify-content-lg-end">
                <img
                  className="order-0 order-lg-1"
                  height="35"
                  src={getProxyUrl(visitingTeamLogo, 35, 35)}
                  alt=""
                />
                <span className="heading-h5 text-transform-none order-lg-0">
                  {visitingTeamName}
                </span>
              </div>
              {visitingTeamPlayers.map((p) => renderPlayer(p))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FutsalFormation;
